/* Läderach editorial interactions: story slider, varieties accordion+map, hero parallax */
(function () {
  function initSlider(root) {
    if (root.dataset.ladInited) return;
    root.dataset.ladInited = '1';
    var track = root.querySelector('.lad-slider__track');
    var slides = root.querySelectorAll('.lad-slider__slide');
    var dots = root.querySelectorAll('.lad-slider__dot');
    if (!track || slides.length < 2) return;
    var idx = 0;
    function go(i) {
      idx = Math.max(0, Math.min(slides.length - 1, i));
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      dots.forEach(function (d, di) {
        d.classList.toggle('is-active', di === idx);
        d.setAttribute('aria-selected', di === idx ? 'true' : 'false');
      });
    }
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.dataset.index, 10) || 0); });
    });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? idx + 1 : idx - 1);
      x0 = null;
    });
    go(0);
  }

  function initVarieties(root) {
    if (root.dataset.ladInited) return;
    root.dataset.ladInited = '1';
    var map = root.querySelector('[data-lad-map]');
    var baseSrc = map ? map.getAttribute('src') : '';
    var items = root.querySelectorAll('[data-lad-acc-item]');
    items.forEach(function (item) {
      var head = item.querySelector('.lad-acc__head');
      if (!head) return;
      head.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (it) {
          it.classList.remove('is-open');
          var h = it.querySelector('.lad-acc__head');
          if (h) h.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          head.setAttribute('aria-expanded', 'true');
          if (map && item.dataset.map) map.setAttribute('src', item.dataset.map);
        } else if (map && baseSrc) {
          map.setAttribute('src', baseSrc);
        }
      });
    });
    var openItem = root.querySelector('[data-lad-acc-item].is-open');
    if (openItem && map && openItem.dataset.map) map.setAttribute('src', openItem.dataset.map);
  }

  function initParallax(root) {
    if (root.dataset.ladInited) return;
    root.dataset.ladInited = '1';
    var media = root.querySelector('.lad-hero__media');
    if (!media) return;
    var ticking = false;
    function update() {
      var r = root.getBoundingClientRect();
      var off = Math.max(-70, Math.min(70, r.top * -0.12));
      media.style.transform = 'translate3d(0,' + off + 'px,0) scale(1.12)';
      ticking = false;
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  function initSplitSlider(root) {
    if (root.dataset.ladInited) return;
    root.dataset.ladInited = '1';
    var track = root.querySelector('.lad-sslider__track');
    var slides = root.querySelectorAll('.lad-sslider__slide');
    var dots = root.querySelectorAll('.lad-sslider__dot');
    var prev = root.querySelector('.lad-sslider__arrow--prev');
    var next = root.querySelector('.lad-sslider__arrow--next');
    if (!track || slides.length < 2) return;
    var idx = 0;
    function go(i) {
      idx = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === idx); });
    }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.index, 10) || 0); }); });
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? idx + 1 : idx - 1);
      x0 = null;
    });
    go(0);
  }

  function initFeatureVideo(root) {
    if (root.dataset.ladInited) return;
    root.dataset.ladInited = '1';
    var section = root.closest('.lad-fvideo') || root;
    var video = root.querySelector('.lad-fvideo__video');
    var btn = root.querySelector('.lad-fvideo__play');
    if (!video || !btn) return;
    btn.addEventListener('click', function () {
      section.classList.add('is-playing');
      video.play();
    });
    video.addEventListener('pause', function () { if (!video.ended) section.classList.remove('is-playing'); });
    video.addEventListener('ended', function () { section.classList.remove('is-playing'); });
  }

  function initAll() {
    document.querySelectorAll('[data-lad-slider]').forEach(initSlider);
    document.querySelectorAll('[data-lad-sslider]').forEach(initSplitSlider);
    document.querySelectorAll('[data-lad-varieties]').forEach(initVarieties);
    document.querySelectorAll('[data-lad-fvideo]').forEach(initFeatureVideo);
    document.querySelectorAll('[data-lad-parallax]').forEach(initParallax);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
})();
